import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
Vue.config.productionTip = false;
//Event Bus
Vue.prototype.$bus = new Vue();
//全域樣式
import '@css/style.scss';
import '@css/layout.scss';
//全域組件
import '@c/index.js';
//base
import base from '@u/base';
//i18n
import i18n from '@/lang';
Vue.prototype.$tp = function () {
	let result = '';
	if (ENV_IS_DEV || this.$te(...arguments)) {
		result = this.$t(...arguments)
			.replace(/\{(.(?!\}))+.\}/gm, '')
			.trim();
	}
	return result;
};
//element ui
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/packages/theme-chalk/src/index.scss';
Vue.use(ElementUI, {
	size: 'medium',
	i18n: (key, value) => i18n.t(key, value),
});
Vue.directive("click-away", {
	bind(el, binding) {
		el.clickAwayEvent = function (event) {
			// 確保點擊範圍不包含 sidebar 本體
			if (!(el.contains(event.target))) {
				binding.value(event);
			}
		};
		document.addEventListener("click", el.clickAwayEvent);
	},
	unbind(el) {
		document.removeEventListener("click", el.clickAwayEvent);
	}
});
new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount('#app');
